export default "__VITE_ASSET__3ee54e97__"